import { render, staticRenderFns } from "./AboutUsView.vue?vue&type=template&id=2280b6a6&scoped=true"
import script from "./AboutUsView.vue?vue&type=script&lang=js"
export * from "./AboutUsView.vue?vue&type=script&lang=js"
import style0 from "./AboutUsView.vue?vue&type=style&index=0&id=2280b6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280b6a6",
  null
  
)

export default component.exports